"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barberino-val-d-elsa": {
    "14e57cf3": [{
      "hkey": "03bcb2a6",
      "slug": "marcialla",
      "name": "Marcialla",
      "primary": true,
      "skipSearch": false
    }],
    "28df1b02": [{
      "hkey": "521449d3",
      "slug": "petrognano",
      "name": "Petrognano",
      "primary": true,
      "skipSearch": false
    }],
    "48bbea13": [{
      "hkey": "65dd970b",
      "slug": "monsanto",
      "name": "Monsanto",
      "primary": true,
      "skipSearch": false
    }],
    "51cf2a0c": [{
      "hkey": "cb958847",
      "slug": "tignano",
      "name": "Tignano",
      "primary": true,
      "skipSearch": false
    }],
    "7e78d19f": [{
      "hkey": "4735763d",
      "slug": "cortine",
      "name": "Cortine",
      "primary": true,
      "skipSearch": false
    }],
    "8e55be43": [{
      "hkey": "6b0f226d",
      "slug": "barberino-tavarnelle",
      "name": "Barberino Tavarnelle",
      "primary": true,
      "skipSearch": false
    }],
    "barberino-val-d-elsa": [{
      "hkey": "6b0f226d",
      "slug": "barberino-tavarnelle",
      "name": "Barberino Tavarnelle",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cb29da46": [{
      "hkey": "018ce387",
      "slug": "sant-appiano",
      "name": "Sant'Appiano",
      "primary": true,
      "skipSearch": false
    }],
    "cd0b8c68": [{
      "hkey": "ec985007",
      "slug": "linari",
      "name": "Linari",
      "primary": true,
      "skipSearch": false
    }],
    "d56d6abd": [{
      "hkey": "b2be3afe",
      "slug": "vico-d-elsa",
      "name": "Vico d'Elsa",
      "primary": true,
      "skipSearch": false
    }],
    "d8d96e49": [{
      "hkey": "03fac5b9",
      "slug": "san-filippo-a-ponzano",
      "name": "San Filippo a Ponzano",
      "primary": true,
      "skipSearch": false
    }]
  },
  "cadrezzate": {
    "0688050a": [{
      "hkey": "f9ba48af",
      "slug": "c-na-dei-ladri",
      "name": "C.na dei Ladri",
      "primary": true,
      "skipSearch": false
    }],
    "0919dea4": [{
      "hkey": "77ac98a3",
      "slug": "montelungo",
      "name": "Montelungo",
      "primary": true,
      "skipSearch": false
    }],
    "0c65f7f9": [{
      "hkey": "a6dc90c8",
      "slug": "case-mogni",
      "name": "Case Mogni",
      "primary": true,
      "skipSearch": false
    }],
    "2457c4d8": [{
      "hkey": "d2986c13",
      "slug": "c-na-margine",
      "name": "C.na Margine",
      "primary": true,
      "skipSearch": false
    }],
    "33108007": [{
      "hkey": "787a6a18",
      "slug": "c-na-della-torbiera",
      "name": "C.na della Torbiera",
      "primary": true,
      "skipSearch": false
    }],
    "6d25490e": [{
      "hkey": "1472c38f",
      "slug": "vignaccia",
      "name": "Vignaccia",
      "primary": true,
      "skipSearch": false
    }],
    "717ca30c": [{
      "hkey": "c1832332",
      "slug": "le-paludi",
      "name": "Le Paludi",
      "primary": true,
      "skipSearch": false
    }],
    "78df30f1": [{
      "hkey": "b17f98be",
      "slug": "cadrezzate-con-osmate",
      "name": "Cadrezzate con Osmate",
      "primary": true,
      "skipSearch": false
    }],
    "8ac33cd3": [{
      "hkey": "8823fd7f",
      "slug": "moncucco",
      "name": "Moncucco",
      "primary": true,
      "skipSearch": false
    }],
    "c85dd4cc": [{
      "hkey": "77df6b9a",
      "slug": "c-na-belvedere",
      "name": "C.na Belvedere",
      "primary": true,
      "skipSearch": false
    }],
    "cadrezzate": [{
      "hkey": "b17f98be",
      "slug": "cadrezzate-con-osmate",
      "name": "Cadrezzate con Osmate",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb741096": [{
      "hkey": "dc7b8ce7",
      "slug": "montecalvo",
      "name": "Montecalvo",
      "primary": true,
      "skipSearch": false
    }],
    "fc71b4ec": [{
      "hkey": "1c1d000e",
      "slug": "gesiolo",
      "name": "Gesiolo",
      "primary": true,
      "skipSearch": false
    }]
  },
  "osmate": {
    "0288326f": [{
      "hkey": "9ad965ec",
      "slug": "cascina-del-monte",
      "name": "Cascina del Monte",
      "primary": true,
      "skipSearch": false
    }],
    "0967fa9d": [{
      "hkey": "640dacc3",
      "slug": "il-casello",
      "name": "Il Casello",
      "primary": true,
      "skipSearch": false
    }],
    "163d8ae1": [{
      "hkey": "f9d92279",
      "slug": "c-na-fontanazza",
      "name": "C.na Fontanazza",
      "primary": true,
      "skipSearch": false
    }],
    "1a45b040": [{
      "hkey": "308aedb2",
      "slug": "villa-solferino",
      "name": "Villa Solferino",
      "primary": true,
      "skipSearch": false
    }],
    "32cf57fb": [{
      "hkey": "65f88263",
      "slug": "i-ronchi",
      "name": "I Ronchi",
      "primary": true,
      "skipSearch": false
    }],
    "35775381": [{
      "hkey": "29a6cc0a",
      "slug": "c-na-della-costa",
      "name": "C.na della Costa",
      "primary": true,
      "skipSearch": false
    }],
    "5059972b": [{
      "hkey": "cd3ea1fd",
      "slug": "monte-pelada",
      "name": "Monte Pelada",
      "primary": true,
      "skipSearch": false
    }],
    "6518cdca": [{
      "hkey": "0542750e",
      "slug": "c-na-bettole",
      "name": "C.na Bettole",
      "primary": true,
      "skipSearch": false
    }],
    "6a18aa4d": [{
      "hkey": "96316687",
      "slug": "c-na-campagna",
      "name": "C.na Campagna",
      "primary": true,
      "skipSearch": false
    }],
    "7db94a40": [{
      "hkey": "a6001202",
      "slug": "c-na-pometta",
      "name": "C.na Pometta",
      "primary": true,
      "skipSearch": false
    }],
    "80d08446": [{
      "hkey": "b17f98be",
      "slug": "cadrezzate-con-osmate",
      "name": "Cadrezzate con Osmate",
      "primary": true,
      "skipSearch": false
    }],
    "osmate": [{
      "hkey": "b17f98be",
      "slug": "cadrezzate-con-osmate",
      "name": "Cadrezzate con Osmate",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "tavarnelle-val-di-pesa": {
    "26f624d4": [{
      "hkey": "74d00785",
      "slug": "passignano",
      "name": "Passignano",
      "primary": true,
      "skipSearch": false
    }],
    "45fe2fc5": [{
      "hkey": "c5d4987f",
      "slug": "sambuca",
      "name": "Sambuca",
      "primary": true,
      "skipSearch": false
    }],
    "a823a029": [{
      "hkey": "06dd9d83",
      "slug": "romita",
      "name": "Romita",
      "primary": true,
      "skipSearch": false
    }],
    "b3c1941c": [{
      "hkey": "e982d37f",
      "slug": "san-donato-in-poggio",
      "name": "San Donato in Poggio",
      "primary": true,
      "skipSearch": false
    }],
    "ba1b92f6": [{
      "hkey": "6b0f226d",
      "slug": "barberino-tavarnelle",
      "name": "Barberino Tavarnelle",
      "primary": true,
      "skipSearch": false
    }],
    "e23068ea": [{
      "hkey": "c3a3978a",
      "slug": "noce",
      "name": "Noce",
      "primary": true,
      "skipSearch": false
    }],
    "tavarnelle-val-di-pesa": [{
      "hkey": "6b0f226d",
      "slug": "barberino-tavarnelle",
      "name": "Barberino Tavarnelle",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;